<div [id]="field.attributes.id" (blur)="touch()">
  @if (options.length > 0) {
  <input
    [(formControl)]="customControl"
    [readonly]="field.attributes.readonly"
    type="email"
    class="form-control"
    matTooltipPosition="above"
    [matTooltip]="
      'Email addresses must be separated by comma (e.g. name1@email.com, name2@email.com)'
    "
    placeholder="Enter email addresses and/or choose from existing"
  />
  } @else {
  <input
    [(formControl)]="customControl"
    [readonly]="field.attributes.readonly"
    type="email"
    class="form-control"
    matTooltipPosition="above"
    [matTooltip]="
      'Email addresses must be separated by comma (e.g. name1@email.com, name2@email.com)'
    "
    placeholder="Enter email addresses"
  />
  } @for (option of options; track option) {
  <div>
    <label>
      <input
        type="checkbox"
        [(checklist)]="value"
        [checklistValue]="option.id"
        [disabled]="disabled"
      />
      <span>{{ option.value }}</span>
    </label>
  </div>
  }
</div>
